import CalcolatoreITRA from "./components/Calcolatore";

export default function App() {
  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <CalcolatoreITRA />
    </div>
  );
}
